// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.index-module__head-container__eckQ0 {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.index-module__head-container__eckQ0 .index-module__left-section__wWEph,
.index-module__head-container__eckQ0 .index-module__left-section2__z2anG {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 1rem;
}
.index-module__head-container__eckQ0 .index-module__right-section-filter__tFtCP {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
  gap: 1rem;
}
.index-module__head-container__eckQ0 .index-module__right-section-filter-top__PgaaP {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}
.index-module__head-container__eckQ0 .index-module__right-section__Pwbw9 {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  gap: 1rem;
}
.index-module__head-container__eckQ0 .index-module__abr-penalty-report-left-section__KV2mz {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 1rem;
}
.index-module__head-container__eckQ0 .index-module__abr-penalty-report-right-section__pcTLL {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
  gap: 1rem;
}
.index-module__head-container__eckQ0 .index-module__abr-penalty-report-right-section__pcTLL .index-module__multi-filter__BCwW1 {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.5rem;
}
@media only screen and (max-width: 1072px) {
  .index-module__head-container__eckQ0 .index-module__left-section2__z2anG {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }
}
@media only screen and (max-width: 786px) {
  .index-module__head-container__eckQ0 .index-module__left-section__wWEph,
  .index-module__head-container__eckQ0 .index-module__left-section2__z2anG {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }
}
@media only screen and (max-width: 592px) {
  .index-module__head-container__eckQ0 .index-module__right-section__Pwbw9 {
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;
  }
  .index-module__head-container__eckQ0 .index-module__right-section-filter-top__PgaaP {
    justify-content: space-between;
    align-items: center;
  }
}
@media only screen and (max-width: 527px) {
  .index-module__head-container__eckQ0 {
    flex-direction: column;
    justify-content: flex-start;
    gap: 1rem;
  }
  .index-module__head-container__eckQ0 .index-module__left-section__wWEph {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .index-module__head-container__eckQ0 .index-module__left-section2__z2anG {
    flex-direction: column;
  }
  .index-module__head-container__eckQ0 .index-module__right-section__Pwbw9 {
    flex-direction: row;
  }
}
.index-module__show-penalty-amount__ea1f_ {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  gap: 4px;
  font-weight: 400;
  font-size: 0.9rem;
  margin-top: 1rem;
  gap: 1.5rem;
}
@media only screen and (max-width: 425px) {
  .index-module__show-penalty-amount__ea1f_ {
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;
    gap: 0.4rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Reports/AdvanceBookingRequestReport/index.module.less"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;;EAEE,WAAW;EACX,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,SAAS;AACX;AACA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;AACA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,qBAAqB;EACrB,SAAS;AACX;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,SAAS;AACX;AACA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;EACzB;AACF;AACA;EACE;;IAEE,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;EACzB;AACF;AACA;EACE;IACE,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;EACvB;EACA;IACE,8BAA8B;IAC9B,mBAAmB;EACrB;AACF;AACA;EACE;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,SAAS;EACX;EACA;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE;IACE,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;EACb;AACF","sourcesContent":[".head-container {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.head-container .left-section,\n.head-container .left-section2 {\n  width: 100%;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 1rem;\n}\n.head-container .right-section-filter {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: flex-end;\n  gap: 1rem;\n}\n.head-container .right-section-filter-top {\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n}\n.head-container .right-section {\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-end;\n  gap: 1rem;\n}\n.head-container .abr-penalty-report-left-section {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  gap: 1rem;\n}\n.head-container .abr-penalty-report-right-section {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: flex-end;\n  gap: 1rem;\n}\n.head-container .abr-penalty-report-right-section .multi-filter {\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 0.5rem;\n}\n@media only screen and (max-width: 1072px) {\n  .head-container .left-section2 {\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: flex-start;\n  }\n}\n@media only screen and (max-width: 786px) {\n  .head-container .left-section,\n  .head-container .left-section2 {\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: flex-start;\n  }\n}\n@media only screen and (max-width: 592px) {\n  .head-container .right-section {\n    flex-direction: column;\n    justify-content: flex-end;\n    align-items: flex-end;\n  }\n  .head-container .right-section-filter-top {\n    justify-content: space-between;\n    align-items: center;\n  }\n}\n@media only screen and (max-width: 527px) {\n  .head-container {\n    flex-direction: column;\n    justify-content: flex-start;\n    gap: 1rem;\n  }\n  .head-container .left-section {\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n  }\n  .head-container .left-section2 {\n    flex-direction: column;\n  }\n  .head-container .right-section {\n    flex-direction: row;\n  }\n}\n.show-penalty-amount {\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-end;\n  gap: 4px;\n  font-weight: 400;\n  font-size: 0.9rem;\n  margin-top: 1rem;\n  gap: 1.5rem;\n}\n@media only screen and (max-width: 425px) {\n  .show-penalty-amount {\n    flex-direction: column;\n    justify-content: flex-end;\n    align-items: flex-end;\n    gap: 0.4rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"head-container": `index-module__head-container__eckQ0`,
	"left-section": `index-module__left-section__wWEph`,
	"left-section2": `index-module__left-section2__z2anG`,
	"right-section-filter": `index-module__right-section-filter__tFtCP`,
	"right-section-filter-top": `index-module__right-section-filter-top__PgaaP`,
	"right-section": `index-module__right-section__Pwbw9`,
	"abr-penalty-report-left-section": `index-module__abr-penalty-report-left-section__KV2mz`,
	"abr-penalty-report-right-section": `index-module__abr-penalty-report-right-section__pcTLL`,
	"multi-filter": `index-module__multi-filter__BCwW1`,
	"show-penalty-amount": `index-module__show-penalty-amount__ea1f_`
};
export default ___CSS_LOADER_EXPORT___;
